import { BasicLeadFormWithQuestion } from "@component/assets/AbstractLeadForm/Steps/BasicLeadFormWithQuestion";
import { Config } from "@config";
import type { ReactNode } from "react";
import React from "react";

export class LeadForm extends BasicLeadFormWithQuestion {
	protected renderPrivacyStatement(): ReactNode {
		return (
			<div className="text-center pt-2 mt-auto">
				A lenti gomb megnyomásával elfogadom az{" "}
				<a
					href={Config.getBankmonitorUrl("/adatvedelem/")}
					// biome-ignore lint/a11y/noBlankTarget: in-page link
					target="_blank"
				>
					adatvédelmi szabályzatba
				</a>{" "}
				és az Online Lakástakarék Pénztár{" "}
				<a
					href={Config.buildSsrFriendlyUrl(
						"BM_BASE_DOCS_URL",
						"/public/promocio/LTP_emag_promo_20250501_20250531.pdf",
					)}
					download="LTP_emag_promo_20250501_20250531.pdf"
					// biome-ignore lint/a11y/noBlankTarget: in-page link
					target="_blank"
				>
					promóciós szabályzatba
				</a>{" "}
				foglaltakat.
			</div>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
